import { CardContainerContextProvider } from 'crm-cards-sdk/internal/CardContainerContext';
import { getCrmContainerContentId } from '../utils/crmContainerContentUtils';
import { useLocationService } from '../internal/LocationServiceContext';
import { useDragDropComponentsContext } from 'crm-cards-sdk/internal/DragDropComponentsContext';
import { useCallback, useMemo } from 'react';
import { createContainerContentKey } from './createContainerContentKey';
import Raven from 'raven-js';
import LinkCardActionButtonList from 'crm-cards-sdk/action-formatters/LinkCardActionButtonList';
import { useCardLocationContext } from 'crm-cards-sdk/internal/CardLocationContext';
import CollapsibleCardFormatterWithAPI from '../internal/cardFormatterDecorators/CollapsibleCardFormatterWithAPI';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CardStackContainerFormatter({
  containerId,
  contents,
  CrmContainerContentRenderer,
  topSlot,
  layout,
  observerManager,
  CardFormatter = CollapsibleCardFormatterWithAPI
}) {
  const dragDropComponents = useDragDropComponentsContext();
  const {
    reorderable = false
  } = layout;
  const {
    updateCardOrder
  } = useLocationService();
  const {
    location
  } = useCardLocationContext();
  const handleUpdateCardOrder = useCallback(orderedCardIds => {
    if (updateCardOrder) {
      updateCardOrder(orderedCardIds);
    } else {
      Raven.captureException(new Error('CardStackContainerFormatter: card order updated but no updateCardOrder present in LocationService, card order will not be saved'));
    }
  }, [updateCardOrder]);
  const renderContainerContents = useCallback(containerOrCard => /*#__PURE__*/_jsx(CrmContainerContentRenderer, {
    content: containerOrCard
  }, createContainerContentKey(containerId, containerOrCard)), [CrmContainerContentRenderer, containerId]);
  const renderedContents = useMemo(() => {
    if (reorderable && dragDropComponents != null && dragDropComponents.DragList != null) {
      return /*#__PURE__*/_jsx(dragDropComponents.DragList, {
        onOrderChange: handleUpdateCardOrder,
        dragGroupId: containerId || location,
        orderedItems: contents.map(containerOrCard => ({
          ariaLabel: `${containerOrCard.type === 'CARD' ? containerOrCard.definition.cardTitle : containerOrCard.label}`,
          id: getCrmContainerContentId(containerOrCard),
          children: renderContainerContents(containerOrCard)
        }))
      });
    }
    if (reorderable && dragDropComponents == null) {
      Raven.captureMessage('CardStackContainerFormatter: no dragDropComponents passed in for location with reorderable=true, drag and drop functionality cannot be used');
    }
    return contents.map(renderContainerContents);
  }, [reorderable, dragDropComponents, contents, renderContainerContents, handleUpdateCardOrder, containerId, location]);
  return /*#__PURE__*/_jsxs(CardContainerContextProvider, {
    value: {
      DefaultCardFormatter: CardFormatter,
      reorderable,
      observerManager,
      ActionFormatter: LinkCardActionButtonList
    },
    children: [topSlot, renderedContents]
  });
}